<template>
  <transition mode="out-in">
    <div class="row pt-5 pt-md-0 pb-5" key="produto">
      <div
        class="col-md-3 pt-4"
        v-for="(produto, index) in produtosVisiveis"
        :key="index"
      >
        <router-link
          v-if="produtosAtivos[produto.id] == 1 || produto.active == 'true'"
          :to="{ name: produto.id }"
        >
          <div
            class="card product shadow text-center d-flex justify-content-center"
          >
            <div class="card-body">
              <span class="material-icons">{{ produto.material_icon }}</span>
              <p class="card-title">{{ produto.name }}</p>
              <p class="card-text">{{ produto.desc }}</p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-md-3 pt-4" v-if="cardAdd">
        <div
          class="card add_produto"
          title="Adquirir mais produtos"
          data-toggle="modal"
          data-target="#adquirirNovoProduto"
        >
          <div class="card-body">
            <h1>+</h1>
          </div>
        </div>
      </div>

      <ModalNovoProduto />
    </div>
  </transition>
</template>


<script>
import { api } from "@/services.js";
import produtosList from "../produtos.json";
import produtosListConsultor from "../produtos_consultor.json";
import ModalNovoProduto from "@/components/NovoProdutoModal.vue";
export default {
  name: "ProdutosLista",
  components: {
    ModalNovoProduto,
  },
  props: ["urlParams"],
  data() {
    return {
      produtosLista: produtosList.produto,
      produtosPorPagina: 10,
      produtosAtivos: [],
      cardAdd: false,
    };
  },
  computed: {
  url() {
    const query = window.location.search;
    return `/produto${query}`;
  },
  produtosVisiveis() {
    return this.produtosLista.filter(
      (p) =>
        this.produtosAtivos[p.id] == 1 ||
        p.active == "true" ||
        p.active == 1 // em caso de número
    );
  },
},

  methods: {
    async getProdutos() {
      this.produtosLista = null;
      api.get(this.url).then((response) => {
        this.produtosLista = response.data;
      });
    },
    getProductsActive() {
      api.get("/api/CdlBh/ListaProdutosAtivos").then((response) => {
        this.produtosAtivos = response.data;
      });
    },
  },
  watch: {
    url() {},
  },
  created() {
    const dadosUsuario = this.$store.getters.getUsuario;
    if (dadosUsuario.carteira) {
      this.produtosLista = produtosListConsultor.produto;
    } else {
      this.produtosLista = produtosList.produto;
      this.cardAdd = true;
      this.getProductsActive();
    }
  },
};
</script>
<style lang="scss" scoped>
.add_produto {
  border: 2px dashed #00a04e;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: #00a04e;
  min-height: 200px;
  .card-body {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
    }
  }
}
</style>
